import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { useTheme } from "@mui/material";
import { Text, View } from "@react-pdf/renderer";

export const PDFAppendix = () => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const { palette } = useTheme();

  return (
    <View style={{
      paddingBottom: 20
    }}>
      <Text
        style={{
          ...typographyStyle.h2,
          color: palette.common.black,
        }}
      >
        Appendix
      </Text>
      <Text
        style={{
          ...typographyStyle.body1,
        }}
      >
        Summary of platform considerations
      </Text>
    </View>
  );
};
